/**
 * The engine's judgment version. A recorded take replays to exactly the judgments it earned
 * live under the same version. Bump it with any change that alters a judgment for the same
 * setup and events; a replay under another version is a re-grade, not a replay.
 */
export const GRADING_ENGINE_VERSION = 1;
